import React from "react";

import {
    EuiDescriptionList,
    EuiDescriptionListDescription,
    EuiDescriptionListTitle,
    EuiFlexGroup,
    EuiFlexItem,
    EuiIcon,
} from "@elastic/eui";

import * as S from "../../style";

export default function TripSection({
    headerTitle,
    headerIconType,
    size,
    children,
    isIconSection,
    isActivitySection,
    iconColor,
}) {
    return (
        <S.TripSectionWrapper size={size}>
            <EuiFlexGroup
                justifyContent="flexStart"
                gutterSize="none"
                responsive={false}
            >
                <EuiFlexItem
                    className="trip-section__icon"
                    grow={false}
                    style={{ color: iconColor }}
                >
                    <EuiIcon
                        type={headerIconType}
                        size="l"
                    />
                </EuiFlexItem>
                <EuiFlexItem className="trip-section__content">
                    <EuiDescriptionList>
                        <EuiDescriptionListTitle>
                            <h3>{headerTitle}</h3>
                        </EuiDescriptionListTitle>
                        <EuiDescriptionListDescription>
                            <S.TripSectioDescriptionWrapper
                                isIconSection={isIconSection}
                                isActivitySection={isActivitySection}
                            >
                                {children}
                            </S.TripSectioDescriptionWrapper>
                        </EuiDescriptionListDescription>
                    </EuiDescriptionList>
                </EuiFlexItem>
            </EuiFlexGroup>
        </S.TripSectionWrapper>
    );
}
